"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ColorArea: function() {
        return _index.ColorArea;
    },
    colorAreaCSSVars: function() {
        return _index.colorAreaCSSVars;
    },
    colorAreaClassNames: function() {
        return _index.colorAreaClassNames;
    },
    renderColorArea_unstable: function() {
        return _index.renderColorArea_unstable;
    },
    useColorAreaStyles_unstable: function() {
        return _index.useColorAreaStyles_unstable;
    },
    useColorArea_unstable: function() {
        return _index.useColorArea_unstable;
    }
});
const _index = require("./components/ColorArea/index");
